(() => {
  const plans = [2, 3, 6, 9];
  const edits = [
    { name: 'Soft & Sweet', keys: ['blush', 'latte'], text: 'Berry sweetness meets caramel warmth. Explore Blush over a light touch of Latte.' },
    { name: 'Golden Hour', keys: ['soleil', 'solaris'], text: 'Pistachio and coconut alongside luminous white florals. A sunlit pairing to explore.' },
    { name: 'Petals & Air', keys: ['rose', 'aeris'], text: 'A floral contrast: Turkish rose alongside lavender, cedarwood and quiet musk.' },
    { name: 'After Hours', keys: ['noir', 'crimson'], text: 'Coffee and vanilla meet saffron and amber. Begin with a light touch of each.' }
  ];
  const count = selection => Object.values(selection).reduce((sum, n) => sum + n, 0);
  function bundleTotal(target, products) {
    if (target === 2) return 5000;
    if (target === 3) return 7000;
    if (target === 9) return 17900;
    return products.length ? products[0].price * 5 : 0;
  }
  function change(selection, key, delta, target, products) {
    const product = products.find(p => p.key === key);
    if (!product || (delta > 0 && (!product.available || count(selection) >= target))) return selection;
    const next = { ...selection, [key]: Math.max(0, (selection[key] || 0) + delta) };
    if (target === 9) next[key] = Math.min(1, next[key]);
    if (!next[key]) delete next[key];
    return next;
  }
  const api = { plans, edits, count, bundleTotal, change };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || !window.customElements || customElements.get('paruvea-bundle-builder')) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const icon = name => document.querySelector(`template[data-bundle-icon="${name}"]`).innerHTML;

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
      this.products = this.config.products;
      this.selection = {};
      this.target = 3;
      this.busy = false;
      this.committed = false;
      this.autoOpenedSignature = '';
      this.$ = selector => this.querySelector(selector);
      this.money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: this.config.currency || 'USD' }).format(value / 100);
      this.marketSupported = this.config.currency === 'USD' && this.products.length === 9 && this.products.every(p => p.price === 2699);
      this.renderProducts();
      this.renderEdits();
      this.observer = new IntersectionObserver(entries => {
        this.$('.pbb-mobile-dock').hidden = !entries[0].isIntersecting;
      });
      this.observer.observe(this);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('change', event => {
        if (this.busy || this.committed) return;
        if (event.target.matches('.pbb-plans input')) this.setPlan(Number(event.target.value));
        if (event.target.matches('[data-family]')) this.filter();
      });
      this.$('[data-search]').addEventListener('input', () => this.filter());
      this.$('.pbb-tabs').addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.$('[aria-selected="true"]').dataset.tab;
        const tab = event.key === 'Home' ? 'build' : event.key === 'End' ? 'layer' : current === 'build' ? 'layer' : 'build';
        this.openTab(tab);
        this.$(`[data-tab="${tab}"]`).focus();
      });
      const params = new URLSearchParams(location.search);
      const handles = (params.get('scents') || params.get('seed') || '').split(',').slice(0, 3);
      const matches = [...new Set(handles)].map(handle => this.products.find(p => p.handle === handle || p.key === handle)).filter(p => p?.available);
      if (matches.length) {
        this.selection = Object.fromEntries(matches.map(p => [p.key, 1]));
        this.target = matches.length === 2 ? 2 : 3;
        this.$(`.pbb-plans input[value="${this.target}"]`).checked = true;
        this.message('Your scent matches are ready. Make this combination your own.');
      }
      const requestedSize = Number(params.get('size'));
      if (plans.includes(requestedSize)) this.setPlan(requestedSize);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.documentElement.classList.remove('pbb-confirm-open');
    }
    renderProducts() {
      this.$('[data-products]').innerHTML = this.products.map(p => `<article class="pbb-product" data-key="${escape(p.key)}">
        <a class="pbb-product-image" href="${escape(p.url)}" target="_blank" rel="noopener" aria-label="View ${escape(p.name)}"><img src="${escape(p.image)}" width="320" height="320" alt="${escape(p.name)}" loading="lazy"></a>
        <p class="pbb-family">${escape(p.family)}</p><h3><a href="${escape(p.url)}" target="_blank" rel="noopener">${escape(p.name)}</a></h3>
        <p class="pbb-notes">${escape(p.notes)}</p>
        <div class="pbb-product-controls"><button type="button" data-delta="-1" data-key="${escape(p.key)}" aria-label="Remove one ${escape(p.name)}" title="Remove one ${escape(p.name)}">${icon('minus')}</button>
        <output data-quantity>${p.available ? 'Add to bundle' : 'Sold out'}</output>
        <button type="button" data-delta="1" data-key="${escape(p.key)}" aria-label="Add ${escape(p.name)}" title="Add ${escape(p.name)}">${icon('plus')}</button></div></article>`).join('');
    }
    renderEdits() {
      this.$('[data-recommendations]').innerHTML = edits.map((edit, index) => {
        const pair = edit.keys.map(key => this.products.find(p => p.key === key));
        if (pair.some(p => !p)) return '';
        return `<article class="pbb-edit"><div class="pbb-edit-images">${pair.map(p => `<img src="${escape(p.image)}" width="250" height="250" alt="${escape(p.name)}" loading="lazy">`).join('')}</div>
          <h3>${edit.name}</h3><p>${pair.map(p => escape(p.name)).join(' + ')}</p><p>${edit.text}</p>
          <button type="button" data-edit="${index}" ${pair.some(p => !p.available) ? 'disabled' : ''}>Choose this duo / $50</button></article>`;
      }).join('');
    }
    setPlan(target) {
      if (!plans.includes(target)) return;
      this.target = target;
      this.$(`.pbb-plans input[value="${target}"]`).checked = true;
      if (target === 9) {
        this.selection = Object.fromEntries(this.products.filter(p => p.available).map(p => [p.key, 1]));
      } else {
        let remaining = target;
        this.selection = Object.fromEntries(Object.entries(this.selection).map(([key, n]) => {
          const kept = Math.min(n, remaining);
          remaining -= kept;
          return [key, kept];
        }).filter(([, n]) => n));
      }
      this.message('');
      this.update();
    }
    openConfirm() {
      if (!matchMedia('(max-width: 749px)').matches) return;
      this.$('[data-confirm]').hidden = false;
      document.documentElement.classList.add('pbb-confirm-open');
    }
    closeConfirm() {
      this.$('[data-confirm]').hidden = true;
      document.documentElement.classList.remove('pbb-confirm-open');
    }
    onClick(event) {
      const controls = event.target.closest('.pbb-product-controls');
      const button = event.target.closest('button');
      if (!button && controls) {
        const card = controls.closest('.pbb-product');
        const add = controls.querySelector('[data-delta="1"]');
        if (!card.classList.contains('is-selected') && !add.disabled && !this.busy && !this.committed) {
          this.selection = change(this.selection, card.dataset.key, 1, this.target, this.products);
          this.update();
        }
        return;
      }
      if (!button || button.disabled) return;
      if (button.hasAttribute('data-confirm-close')) return this.closeConfirm();
      if (button.hasAttribute('data-confirm-add')) return this.addToCart();
      if (button.hasAttribute('data-add')) return this.addToCart();
      if (button.dataset.tab) return this.openTab(button.dataset.tab);
      if (button.hasAttribute('data-review')) {
        if (matchMedia('(max-width: 749px)').matches) this.openConfirm();
        else {
          this.$('.pbb-summary').scrollIntoView({ block: 'start' });
          this.$('.pbb-summary').focus({ preventScroll: true });
        }
        return;
      }
      if (this.busy || this.committed) return;
      if (button.hasAttribute('data-delta')) this.selection = change(this.selection, button.dataset.key, Number(button.dataset.delta), this.target, this.products);
      else if (button.hasAttribute('data-remove')) delete this.selection[button.dataset.remove];
      else if (button.hasAttribute('data-clear')) this.selection = {};
      else if (button.hasAttribute('data-edit')) {
        this.selection = Object.fromEntries(edits[Number(button.dataset.edit)].keys.map(key => [key, 1]));
        this.setPlan(2);
        this.openTab('build');
        this.message('Duo selected. This replaces your previous selection.');
      } else return;
      this.update();
    }
    openTab(name) {
      this.querySelectorAll('[data-tab]').forEach(tab => {
        tab.setAttribute('aria-selected', String(tab.dataset.tab === name));
        tab.tabIndex = tab.dataset.tab === name ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
    }
    filter() {
      const search = this.$('[data-search]').value.trim().toLowerCase();
      const family = this.$('[data-family]').value;
      let visible = 0;
      this.querySelectorAll('.pbb-product').forEach(card => {
        const p = this.products.find(p => p.key === card.dataset.key);
        card.hidden = !(`${p.name} ${p.notes}`.toLowerCase().includes(search) && (!family || p.family === family));
        if (!card.hidden) visible++;
      });
      this.$('[data-empty]').hidden = visible > 0;
    }
    update() {
      const total = count(this.selection);
      const full = total === this.target;
      const locked = this.busy || this.committed;
      this.querySelectorAll('.pbb-plans input,[data-clear],[data-edit]').forEach(el => { el.disabled = locked || (el.hasAttribute('data-edit') && edits[Number(el.dataset.edit)].keys.some(k => !this.products.find(p => p.key === k)?.available)); });
      this.querySelectorAll('.pbb-product').forEach(card => {
        const p = this.products.find(p => p.key === card.dataset.key);
        const n = this.selection[p.key] || 0;
        card.classList.toggle('is-selected', n > 0);
        card.querySelector('[data-quantity]').textContent = !p.available ? 'Sold out' : n ? `${n} selected` : 'Add to bundle';
        card.querySelector('[data-delta="-1"]').disabled = locked || !n;
        card.querySelector('[data-delta="1"]').disabled = locked || !p.available || full || (this.target === 9 && n >= 1);
      });
      const entries = Object.entries(this.selection).map(([key, n]) => {
        const p = this.products.find(p => p.key === key);
        return `<li><img src="${escape(p.image)}" width="44" height="44" alt=""><span>${escape(p.name)}${n > 1 ? ` &times; ${n}` : ''}</span><button type="button" data-remove="${escape(key)}" title="Remove ${escape(p.name)}" aria-label="Remove ${escape(p.name)}" ${locked ? 'disabled' : ''}>${icon('x')}</button></li>`;
      });
      for (let i = total; i < this.target; i++) entries.push(`<li class="pbb-unfilled"><span class="pbb-slot">${i + 1}</span><span>${this.target === 6 && i === 5 ? 'Your free fragrance' : 'Choose a fragrance'}</span></li>`);
      this.$('[data-selected]').innerHTML = entries.join('');
      const mobileSlots = [];
      Object.entries(this.selection).forEach(([key, n]) => {
        const p = this.products.find(p => p.key === key);
        for (let i = 0; i < n; i++) mobileSlots.push(`<li><img src="${escape(p.image)}" width="42" height="48" alt="${escape(p.name)}"></li>`);
      });
      for (let i = total; i < this.target; i++) mobileSlots.push(`<li class="is-empty">${i + 1}</li>`);
      this.$('[data-mobile-slots]').innerHTML = mobileSlots.join('');
      this.$('[data-confirm-slots]').innerHTML = mobileSlots.join('');
      this.$('[data-confirm-items]').innerHTML = Object.entries(this.selection).map(([key, n]) => {
        const p = this.products.find(p => p.key === key);
        return `<li><img src="${escape(p.image)}" width="48" height="54" alt=""><span><small>${escape(p.family)}</small><strong>${escape(p.name)}</strong>${n > 1 ? `<em>Quantity ${n}</em>` : ''}</span><b>${this.money(p.price * n)}</b><button type="button" data-remove="${escape(key)}" aria-label="Remove ${escape(p.name)}" ${locked ? 'disabled' : ''}>${icon('x')}</button></li>`;
      }).join('');
      this.$('[data-progress]').max = this.target;
      this.$('[data-progress]').value = total;
      this.$('[data-progress-text]').textContent = `${total} of ${this.target} bottles selected`;
      this.$('[data-mobile-progress]').textContent = `${total}/${this.target} selected${this.marketSupported ? ' / ' + this.money(bundleTotal(this.target, this.products)) : ''}`;
      this.$('[data-incentive]').textContent = this.target === 6 ? (total === 5 ? 'Choose your sixth fragrance. It is free.' : 'Choose six full-size fragrances. Pay for five.') : this.target === 9 ? 'One of every fragrance. The complete nine-scent collection.' : full ? 'Your combination is ready.' : `Choose ${this.target - total} more to complete your ${this.target === 2 ? 'duo' : 'trio'}.`;
      this.$('[data-total]').textContent = this.marketSupported ? this.money(bundleTotal(this.target, this.products)) : '--';
      this.$('[data-original]').textContent = this.marketSupported ? this.money(this.target * 2699) : '';
      const nineBlocked = this.target === 9 && !this.config.nineEnabled;
      const plannedTotal = bundleTotal(this.target, this.products);
      const regularTotal = this.target * 2699;
      this.$('[data-confirm-original]').textContent = this.marketSupported ? this.money(regularTotal) : '--';
      this.$('[data-confirm-total]').textContent = this.marketSupported ? this.money(plannedTotal) : '--';
      this.$('[data-confirm-savings]').textContent = this.marketSupported ? `-${this.money(Math.max(0, regularTotal - plannedTotal))}` : '--';
      const submit = this.$('[data-add]');
      submit.disabled = this.busy || (!this.committed && (!full || !this.marketSupported || nineBlocked));
      submit.textContent = this.committed ? 'Check your cart' : this.busy ? 'Adding your fragrances...' : nineBlocked ? 'Complete Collection / Coming soon' : !this.marketSupported ? 'Offer unavailable in this market' : full ? `Add ${this.target} bottles to cart` : `Select ${this.target - total} more fragrance${this.target - total === 1 ? '' : 's'}`;
      const confirmSubmit = this.$('[data-confirm-add]');
      confirmSubmit.disabled = submit.disabled;
      confirmSubmit.textContent = this.committed ? 'Check your cart' : this.busy ? 'Adding your fragrances...' : nineBlocked ? 'Complete Collection / Coming soon' : !this.marketSupported ? 'Offer unavailable' : full ? `Continue · ${this.money(plannedTotal)} →` : `Choose ${this.target - total} more fragrance${this.target - total === 1 ? '' : 's'}`;
      this.$('[data-price-note]').textContent = nineBlocked ? 'Preview price. Purchase opens when this offer is available.' : 'USD. Shipping and taxes calculated at checkout.';
      const signature = `${this.target}:${Object.entries(this.selection).map(([key, n]) => `${key}-${n}`).sort().join(',')}`;
      if (!full) this.autoOpenedSignature = '';
      if (full && !locked && signature !== this.autoOpenedSignature && matchMedia('(max-width: 749px)').matches) {
        this.autoOpenedSignature = signature;
        this.openConfirm();
      }
    }
    message(text, error = false) {
      this.$('[data-status]').textContent = text;
      this.$('[data-status]').dataset.error = String(error);
      this.$('[data-confirm-status]').textContent = text;
      this.$('[data-confirm-status]').dataset.error = String(error);
    }
    async readCart() {
      for (let attempt = 0; attempt < 3; attempt++) {
        const response = await fetch(`${this.config.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (response.ok) return response.json();
        if (response.status !== 429 || attempt === 2) break;
        await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)));
      }
      throw new Error('Unable to confirm your cart right now.');
    }
    async addToCart() {
      if (this.busy || this.$('[data-add]').disabled) return;
      this.busy = true;
      this.update();
      this.message('');
      let sent = false;
      try {
        if (this.committed) {
          await this.openCartDrawer();
          return;
        }
        // Check the cart before sending; never clear or replace existing items.
        await this.readCart();
        sent = true;
        const response = await fetch(`${this.config.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: Object.entries(this.selection).map(([key, quantity]) => ({ id: this.products.find(p => p.key === key).variant, quantity })) })
        });
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || 'Some fragrances could not be added. Check your cart before trying again.');
        this.committed = true;
        await this.openCartDrawer();
        // The cart owns the added items; unlock this selection for the next bundle.
        this.committed = false;
      } catch (error) {
        if (sent) {
          this.committed = true;
          this.$('[data-cart-link]').hidden = false;
        }
        this.message(sent ? `${error.message} Check your cart before adding again.` : error.message, true);
      } finally {
        this.busy = false;
        this.update();
      }
    }
    async openCartDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        throw new Error('Unable to open your cart right now.');
      }
      const cart = await this.readCart();
      if (typeof window.syncCartProtection === 'function') {
        await window.syncCartProtection(cart);
      }
      // Render only after protection has settled so the button shows the final total.
      const sections = drawer.getSectionsToRender().map(section => section.id);
      const url = new URL(this.config.root, location.origin);
      url.searchParams.set('sections', sections.join(','));
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to refresh your cart right now.');
      const rendered = await response.json();
      if (sections.some(id => !rendered[id])) throw new Error('Unable to refresh your cart right now.');
      this.closeConfirm();
      drawer.classList.remove('is-empty');
      drawer.setActiveElement(this.$('[data-add]'));
      drawer.renderContents({ sections: rendered });
    }
  }
  customElements.define('paruvea-bundle-builder', BundleBuilder);
})();
